<template>
    <div class="row">
        <div class="col-md-12" v-if="list.length === 0">
            <div class="text-center">No Results.</div>
        </div>
        <div class="col-md-3" v-for="(item,index) in list" :key="name+'-card-'+index">
            <div class="card card-flat">
                <div class="card-body" style="padding:10px">
                    <div class="thumb content-group" >
                        <img :src="item.thumbnailUrl" @error="imageError" :data-url="item.thumbnailUrl" alt="" class="img-responsive">
                        <slot name="overlay" :data="item"/>
                    </div>
                    <h5 class=" mt-4 text-center font-size-lg">
                        <a href="#" class="text-default">{{item.name}}</a>
                    </h5>
                    <slot name="buttons" :data="item"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ImageTable",
        components: {
        },
        props: {
            list: {
                type: Array,
                default() {
                    return []
                }
            },
            name: {
                type: String,
                default: function() {
                    return 'imageTable'
                }
            }
        },
        methods: {
            imageError: function(e) {
                e.target.src = e.target.dataset.url
            }
        }
    }
</script>

<style scoped>
</style>
